// Converts snake_case to camelCase
export const camelize = (str: string): string => {
    return str.trim().replace(/([-_\s][a-zA-Z0-9])/g, ($1) => {
        return $1.toUpperCase().replace('-', '').replace('_', '').replace(' ', '');
    });
};

// Converts camelCase to snake_case
export const decamelize = (str: string, separator: string = '_'): string => {
    return str
        .replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`)
        .replace(/([A-Z])([A-Z][a-z])/g, `$1${separator}$2`)
        .replace(/([A-Z]{2,})/g, (match) => match.split('').join(separator))
        .toLowerCase();
};

// Converts all keys in an object from snake_case to camelCase with an option to exclude certain keys
export const camelizeKeys = (
    obj: any,
    excludeFn?: (key: string, convert: (key: string) => string) => string
): any => {
    if (Array.isArray(obj)) {
        return obj.map((item) => camelizeKeys(item, excludeFn));
    }

    if (obj && typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).reduce((acc, key) => {
            const camelizedKey = excludeFn ? excludeFn(key, camelize) : camelize(key);
            acc[camelizedKey] = camelizeKeys(obj[key], excludeFn);
            return acc;
        }, {} as any);
    }
    return obj;
};

// Converts all keys in an object from camelCase to snake_case
export const decamelizeKeys = (
    obj: any,
    callback?: (key: string, convert: (key: string, opts?: any) => string, options?: any) => string
): any => {
    if (Array.isArray(obj)) {
        return obj.map((item) => decamelizeKeys(item, callback));
    }

    if (obj instanceof Date) {
        return obj.toISOString();
    }

    if (obj && typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).reduce((acc, key) => {
            const decamelizedKey = callback
                ? callback(key, (k: string) => decamelize(k), {})
                : decamelize(key);

            acc[decamelizedKey] = decamelizeKeys(obj[key], callback);
            return acc;
        }, {} as any);
    }

    return obj;
};
